module.exports = __webpack_public_path__ + "img/busca-tematica-agua-dolce.05513659.jpg";